import { render, staticRenderFns } from "./buttonFloatingNotification.vue?vue&type=template&id=32acf0c6&"
import script from "./buttonFloatingNotification.vue?vue&type=script&lang=js&"
export * from "./buttonFloatingNotification.vue?vue&type=script&lang=js&"
import style0 from "./buttonFloatingNotification.vue?vue&type=style&index=0&id=32acf0c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports